import moment from 'moment/min/moment-with-locales';

export function setLocale(locale: string) {
  moment.locale(locale);
}

export default moment;
